import { BaseService } from "./base.service";
import { Http } from "./http.init";
import { assert } from "@/core";
export class NewsService extends BaseService {
  constructor() {
    super("news");
  }
  async create(payload = {}) {
    assert.object(payload, { required: true });
    const response = await new Http({
      auth: true,
      headers: { "Content-Type": "multipart/form-data" }
    }).post(`${this.entity}`, payload);
    return response.data;
  }

  async update(id, payload = {}) {
    assert.object(payload, { required: true });
    const response = await new Http({
      auth: true,
      headers: { "Content-Type": "multipart/form-data" }
    }).post(`${this.entity}/${id}`, payload);
    return response.data;
  }
}
